import React from "react";
import { 
  FaHtml5, FaCss3Alt, FaReact, FaGitAlt, 
  FaAws, FaBootstrap, FaLaravel, FaNpm, FaSass, FaGithub,
  FaLeaf, FaServer, FaListAlt
} from "react-icons/fa";
import { 
  SiTailwindcss, SiTypescript, SiMongodb, SiPostgresql, SiPostman, 
  SiPm2, SiJavascript, SiRedux, SiFirebase, SiExpress, SiNodedotjs, 
  SiNetlify, SiVercel, SiHeroku, SiChartdotjs, 
  SiChakraui, SiJsonwebtokens, SiNextdotjs, SiNodemon, 
  SiSemanticuireact, SiThreedotjs, SiVite, SiApache 
} from "react-icons/si";

interface TechBadge {
  name: string;
  icon: React.ReactNode;
  color: string; // Tailwind color class for border/glow
  category: "frontend" | "backend" | "devops";
}

const TECH_BADGES: TechBadge[] = [
  // Frontend/UI (13 Badges)
  { name: "JavaScript", icon: <SiJavascript size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "HTML5", icon: <FaHtml5 size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "TypeScript", icon: <SiTypescript size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "CSS3", icon: <FaCss3Alt size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "React", icon: <FaReact size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "Redux", icon: <SiRedux size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "Tailwind CSS", icon: <SiTailwindcss size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "Bootstrap", icon: <FaBootstrap size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "Sass", icon: <FaSass size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "DaisyUI", icon: <FaLeaf size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "Chakra UI", icon: <SiChakraui size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "Semantic UI React", icon: <SiSemanticuireact size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },
  { name: "Three.js", icon: <SiThreedotjs size={22} />, color: "border-cyber-cyan text-cyber-cyan shadow-glow-cyan-sm", category: "frontend" },

  // Databases & Backend (10 Badges)
  { name: "Node.js", icon: <SiNodedotjs size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },
  { name: "Express.js", icon: <SiExpress size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },
  { name: "MongoDB", icon: <SiMongodb size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },
  { name: "PostgreSQL", icon: <SiPostgresql size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },
  { name: "Firebase", icon: <SiFirebase size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },
  { name: "Laravel", icon: <FaLaravel size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },
  { name: "Next.js", icon: <SiNextdotjs size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },
  { name: "Apache", icon: <SiApache size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },
  { name: "JWT", icon: <SiJsonwebtokens size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },
  { name: "Nodemon", icon: <SiNodemon size={22} />, color: "border-cyber-green text-cyber-green shadow-glow-green-sm", category: "backend" },

  // DevOps / Tools (12 Badges)
  { name: "Git", icon: <FaGitAlt size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "GitHub", icon: <FaGithub size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "Postman", icon: <SiPostman size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "NPM", icon: <FaNpm size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "AWS", icon: <FaAws size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "Render", icon: <FaServer size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "Vercel", icon: <SiVercel size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "Netlify", icon: <SiNetlify size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "Heroku", icon: <SiHeroku size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "Vite", icon: <SiVite size={22} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "PM2", icon: <SiPm2 size={24} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "React Hook Form", icon: <FaListAlt size={20} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" },
  { name: "Chart.js", icon: <SiChartdotjs size={20} />, color: "border-cyber-purple text-cyber-purple shadow-glow-purple-sm", category: "devops" }
];

export const Skills = () => {
  return (
    <div id="skills" className="w-full min-h-screen bg-cyber-black text-gray-300 py-20 px-6 flex items-center justify-center border-t border-cyber-green/10">
      <div className="max-w-6xl w-full space-y-12">
        <div className="text-center md:text-left">
          <h2 className="text-3xl font-mono font-bold text-cyber-green inline border-b-2 border-cyber-green pb-2">
            TECH_STACK // CAPABILITIES
          </h2>
          <p className="mt-4 font-mono text-sm text-cyber-gray-400">
            Interactive, highly-tuned components powering modern, full-stack systems.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Frontend/UI Column */}
          <div className="border border-cyber-blue/20 bg-cyber-darker/50 p-6 rounded-2xl space-y-6 hover:border-cyber-blue/40 transition duration-300">
            <h3 className="font-mono text-base font-bold text-cyber-blue border-b border-cyber-blue/10 pb-2">
              01 // FRONTEND_UI
            </h3>
            <div className="grid grid-cols-2 gap-3">
              {TECH_BADGES.filter(b => b.category === "frontend").map((badge, idx) => (
                <div
                  key={idx}
                  className={`flex items-center space-x-2.5 p-3 bg-cyber-black border rounded-xl hover:scale-105 duration-300 hover-glow-blue cursor-pointer ${badge.color}`}
                >
                  <div className="flex-shrink-0">{badge.icon}</div>
                  <span className="font-mono text-xs text-white font-bold leading-tight">{badge.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Databases & Backend Column */}
          <div className="border border-cyber-green/20 bg-cyber-darker/50 p-6 rounded-2xl space-y-6 hover:border-cyber-green/40 transition duration-300">
            <h3 className="font-mono text-base font-bold text-cyber-green border-b border-cyber-green/10 pb-2">
              02 // BACKEND_DATABASES
            </h3>
            <div className="grid grid-cols-2 gap-3">
              {TECH_BADGES.filter(b => b.category === "backend").map((badge, idx) => (
                <div
                  key={idx}
                  className={`flex items-center space-x-2.5 p-3 bg-cyber-black border rounded-xl hover:scale-105 duration-300 hover-glow-green cursor-pointer ${badge.color}`}
                >
                  <div className="flex-shrink-0">{badge.icon}</div>
                  <span className="font-mono text-xs text-white font-bold leading-tight">{badge.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* DevOps/Tools Column */}
          <div className="border border-purple-500/20 bg-cyber-darker/50 p-6 rounded-2xl space-y-6 hover:border-purple-500/40 transition duration-300">
            <h3 className="font-mono text-base font-bold text-purple-400 border-b border-purple-500/10 pb-2">
              03 // DEVOPS_TOOLS
            </h3>
            <div className="grid grid-cols-2 gap-3">
              {TECH_BADGES.filter(b => b.category === "devops").map((badge, idx) => (
                <div
                  key={idx}
                  className={`flex items-center space-x-2.5 p-3 bg-cyber-black border rounded-xl hover:scale-105 duration-300 hover:border-purple-400 hover:shadow-purple-500/40 cursor-pointer ${badge.color}`}
                >
                  <div className="flex-shrink-0">{badge.icon}</div>
                  <span className="font-mono text-xs text-white font-bold leading-tight">{badge.name}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Skills;
